module.exports = __webpack_public_path__ + "statics/img/4-1.a7ae0ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/product/icon/4-1.png
// module id = ivNK
// module chunks = 1